import { type ReactElement } from "react";

import {
    RiBox3Line,
    RiFileList3Line,
    RiPuzzleLine,
    RiTeamLine,
    RiUserLine,
} from "@remixicon/react";

import { SUBMENU_ICON_SIZE } from "../constants";

/**
 * Icons for the entity kinds the catalog submenu links to, replacing
 * `useApp().getSystemIcon("kind:*")`.
 *
 * The app's icon bundle still resolves those keys to Material UI icons — they
 * come from `@backstage/app-defaults` — so calling `getSystemIcon` here would
 * have reintroduced MUI into an otherwise MUI-free sidebar. Mapping the five
 * kinds we actually link to is cheaper than registering an
 * `IconBundleBlueprint` override, and keeps this change scoped to the nav.
 *
 * The trade-off is that the rail and the catalog's own kind icons can drift.
 * If that becomes a problem, promote this map to an `IconBundleBlueprint`
 * extension so the whole app picks up the Remix icons at once.
 */
export const kindIcons: Record<string, ReactElement> = {
    api: <RiPuzzleLine size={SUBMENU_ICON_SIZE} aria-hidden />,
    component: <RiBox3Line size={SUBMENU_ICON_SIZE} aria-hidden />,
    group: <RiTeamLine size={SUBMENU_ICON_SIZE} aria-hidden />,
    template: <RiFileList3Line size={SUBMENU_ICON_SIZE} aria-hidden />,
    user: <RiUserLine size={SUBMENU_ICON_SIZE} aria-hidden />,
};
